import createIcon from './utils/createIcon.js';
import '@babel/runtime/helpers/esm/extends';
import 'react';
import './utils/SvgIcon.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react-desc';
import '@elliemae/ds-classnames';

/* eslint-disable */
var ChevronSmallUp = createIcon({
  paths: ['M9.499 6.969a.503.503 0 0 0-.313.109l-5 4a.5013.5013 0 0 0-.078.703c.173.214.488.25.703.078l4.688-3.75 4.688 3.75c.218.172.531.136.703-.078a.5004.5004 0 0 0-.078-.703l-5-4a.501.501 0 0 0-.313-.109z'],
  height: 20,
  width: 20
});

export default ChevronSmallUp;
//# sourceMappingURL=ChevronSmallUp.js.map
